export function IsWorker(): boolean {
  return (
    typeof self === "object" &&
    typeof (self as any).importScripts === "function" &&
    typeof window === "undefined"
  )
}
